/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export default {
  'Type something': 'Bitte geben Sie einen Text ein',
  Advanced: 'Fortgeschritten',
  'About Jodit': 'Über Jodit',
  'Jodit Editor': 'Jodit Editor',
  "Jodit User's Guide": 'Das Jodit Benutzerhandbuch',
  'contains detailed help for using': 'beinhaltet ausführliche Informationen wie Sie den Editor verwenden können.',
  'For information about the license, please go to our website:': 'Für Informationen zur Lizenz, besuchen Sie bitte unsere Web-Präsenz:',
  'Buy full version': 'Vollversion kaufen',
  'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright © XDSoft.net - Chupurnov Valeriy. Alle Rechte vorbehalten.',
  Anchor: 'Anker',
  'Open in new tab': 'In neuer Registerkarte öffnen',
  'Open in fullsize': 'Editor in voller Größe öffnen',
  'Clear Formatting': 'Formatierung löschen',
  'Fill color or set the text color': 'Füllfarbe oder Textfarbe ändern',
  Redo: 'Wiederholen',
  Undo: 'Rückgängig machen',
  Bold: 'Fett',
  Italic: 'Kursiv',
  'Insert Unordered List': 'Unsortierte Liste einfügen',
  'Insert Ordered List': 'Nummerierte Liste einfügen',
  'Align Center': 'Mittig ausrichten',
  'Align Justify': 'Blocksatz',
  'Align Left': 'Links ausrichten',
  'Align Right': 'Rechts ausrichten',
  'Insert Horizontal Line': 'Horizontale Linie einfügen',
  'Insert Image': 'Bild einfügen',
  'Insert file': 'Datei einfügen',
  'Insert youtube/vimeo video': 'Youtube/vimeo Video einfügen',
  'Insert link': 'Link einfügen',
  'Font size': 'Schriftgröße',
  'Font family': 'Schriftfamilie',
  'Insert format block': 'Formatblock einfügen',
  Normal: 'Normal',
  'Heading 1': 'Überschrift 1',
  'Heading 2': 'Überschrift 2',
  'Heading 3': 'Überschrift 3',
  'Heading 4': 'Überschrift 4',
  Quote: 'Zitat',
  Code: 'Code',
  Insert: 'Einfügen',
  'Insert table': 'Tabelle einfügen',
  'Decrease Indent': 'Einzug verkleinern',
  'Increase Indent': 'Einzug vergrößern',
  'Select Special Character': 'Sonderzeichen auswählen',
  'Insert Special Character': 'Sonderzeichen einfügen',
  'Paint format': 'Format kopieren',
  'Change mode': 'Änderungsmodus',
  Margins: 'Ränder',
  top: 'Oben',
  right: 'Rechts',
  bottom: 'Unten',
  left: 'Links',
  Styles: 'CSS Stil',
  Classes: 'CSS Klassen',
  Align: 'Ausrichtung',
  Right: 'Rechts',
  Center: 'Zentriert',
  Left: 'Links',
  '--Not Set--': 'Keine',
  Src: 'Pfad',
  Title: 'Titel',
  Alternative: 'Alternativer Text',
  Link: 'Link',
  'Open link in new tab': 'Link in neuem Tab öffnen',
  Image: 'Bild',
  file: 'Datei',
  'Image properties': 'Bildeigenschaften',
  Cancel: 'Abbrechen',
  Ok: 'OK',
  'Your code is similar to HTML. Keep as HTML?': 'Ihr Text ähnelt HTML-Code. Als HTML beibehalten?',
  'Paste as HTML': 'Als HTML einfügen?',
  Keep: 'Original speichern',
  Clean: 'Säubern',
  'Insert as Text': 'Als Text einfügen',
  'Word Paste Detected': 'In Word formatierter Text erkannt',
  'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?': 'Der Inhalt, den Sie einfügen, stammt aus einem Microsoft Word / Excel-Dokument. Möchten Sie das Format erhalten oder bereinigen?',
  'Insert only Text': 'Nur Text einfügen',
  'File Browser': 'Dateibrowser',
  'Error on load list': 'Fehler beim Laden der Liste',
  'Error on load folders': 'Fehler beim Laden der Ordner',
  'Are you sure?': 'Sind Sie sicher?',
  'Enter Directory name': 'Geben Sie den Verzeichnisnamen ein',
  'Create directory': 'Verzeichnis erstellen',
  'type name': 'Typname',
  'Drop image': 'Bild hier hinziehen',
  'Drop file': 'Datei löschen',
  'or click': 'oder hier klicken',
  'Alternative text': 'Alternativtext',
  Browse: 'Auswählen',
  Upload: 'Hochladen',
  Background: 'Hintergrund',
  Text: 'Text',
  Top: 'Oben',
  Middle: 'Mittig',
  Bottom: 'Unten',
  'Insert column before': 'Spalte davor einfügen',
  'Insert column after': 'Spalte danach einfügen',
  'Insert row above': 'Zeile oberhalb einfügen',
  'Insert row below': 'Zeile unterhalb einfügen',
  'Delete table': 'Tabelle löschen',
  'Delete row': 'Zeile löschen',
  'Delete column': 'Spalte löschen',
  'Empty cell': 'Zelle leeren',
  Delete: 'Löschen',
  'Strike through': 'Durchstreichen',
  Underline: 'Unterstreichen',
  Break: 'Pause',
  'Search for': 'Suche nach',
  'Replace with': 'Ersetzen durch',
  Replace: 'Ersetzen',
  Edit: 'Bearbeiten',
  'Vertical align': 'Vertikale Ausrichtung',
  'Horizontal align': 'Horizontale Ausrichtung',
  Filter: 'Filter',
  'Sort by changed': 'Sortieren nach geändert',
  'Sort by name': 'Nach Name sortieren',
  'Sort by size': 'Nach Größe sortiert',
  'Add folder': 'Ordner hinzufügen',
  'Split vertical': 'Vertikal unterteilen',
  'Split horizontal': 'Horizontal unterteilen',
  Split: 'Unterteilen',
  Merge: 'Vereinen',
  'Add column': 'Spalte hinzufügen',
  'Add row': 'Zeile hinzufügen',
  Border: 'Rand',
  'Embed code': 'Code einbetten',
  Update: 'Aktualisieren',
  superscript: 'Hochstellen',
  subscript: 'Tiefstellen',
  'Cut selection': 'Auswahl ausschneiden',
  Paste: 'Einfügen',
  'Choose Content to Paste': 'Wählen Sie den Inhalt zum Einfügen aus',
  'Chars: %d': 'Zeichen: %d',
  'Words: %d': 'Wörter: %d',
  All: 'Alles markieren',
  'Select %s': 'Markieren: %s',
  'Select all': 'Alles markieren',
  source: 'HTML',
  bold: 'Fett gedruckt',
  italic: 'Kursiv',
  brush: 'Bürste',
  link: 'Verknüpfung',
  undo: 'Rückgängig machen',
  redo: 'Wiederholen',
  table: 'Tabelle',
  image: 'Bild',
  eraser: 'Radiergummi',
  paragraph: 'Absatz',
  fontsize: 'Schriftgröße',
  video: 'Video',
  font: 'Schriftart',
  about: 'Über',
  print: 'Drucken',
  underline: 'Unterstreichen',
  strikethrough: 'Durchstreichen',
  indent: 'Einzug',
  outdent: 'Herausstellen',
  fullsize: 'Vollgröße',
  shrink: 'Schrumpfen',
  hr: 'die Linie',
  ul: 'Liste von',
  ol: 'Nummerierte Liste',
  'Lower Alpha': 'Standard, Alphabet (klein)',
  'Upper Alpha': 'Standard, Alphabet (gross)',
  'Lower Roman': 'Römisch (klein)',
  'Upper Roman': 'Römisch (gross)',
  'Lower Greek': 'Griechisch',
  cut: 'Schneiden',
  selectall: 'Wählen Sie Alle aus',
  'Open link': 'Link öffnen',
  'Edit link': 'Link bearbeiten',
  'No follow': 'Nofollow-Attribut',
  Unlink: 'Link entfernen',
  Eye: 'Ansehen',
  pencil: 'Bearbeiten',
  ' URL': 'URL',
  Reset: 'Wiederherstellen',
  Save: 'Speichern',
  'Save as ...': 'Speichern als',
  Resize: 'Größe ändern',
  Crop: 'Größe anpassen',
  Width: 'Breite',
  Height: 'Höhe',
  'Keep Aspect Ratio': 'Seitenverhältnis beibehalten',
  Yes: 'Ja',
  No: 'Nein',
  Remove: 'Entfernen',
  Select: 'Markieren',
  'You can only edit your own images. Download this image on the host?': 'Sie können nur Ihre eigenen Bilder bearbeiten. Dieses Bild auf den Host herunterladen?',
  'The image has been successfully uploaded to the host!': 'Das Bild wurde erfolgreich auf den Server hochgeladen!',
  palette: 'Palette',
  'There are no files': 'In diesem Verzeichnis befinden sich keine Dateien.',
  Rename: 'Umbenennen',
  'Enter new name': 'Geben Sie einen neuen Namen ein',
  preview: 'Vorschau',
  download: 'Herunterladen',
  'Paste from clipboard': 'Aus Zwischenablage einfügen',
  "Your browser doesn't support direct access to the clipboard.": 'Ihr Browser unterstützt keinen direkten Zugriff auf die Zwischenablage.',
  'Copy selection': 'Auswahl kopieren',
  copy: 'Kopieren',
  'Border radius': 'Radius für abgerundete Ecken',
  'Show all': 'Alle anzeigen',
  Apply: 'Anwenden',
  'Please fill out this field': 'Bitte füllen Sie dieses Feld aus',
  'Please enter a web address': 'Bitte geben Sie eine Web-Adresse ein',
  Default: 'Standard',
  Circle: 'Kreis',
  Dot: 'Punkte',
  Quadrate: 'Quadrate',
  Find: 'Suchen',
  'Find Previous': 'Suche vorherige',
  'Find Next': 'Weitersuchen',
  'Insert className': 'className (CSS) einfügen',
  'Press Alt for custom resizing': 'Drücken Sie Alt für benutzerdefinierte Größenanpassung'
};